function filterVariantImages(variantId, isInitialLoad = false) {
  if (!variantId || !window.variantImageMapping || !window.variantImageMapping.mapping) {
    const gallery = document.querySelector('product-gallery');
    if (gallery) gallery.classList.add('is-ready');
    return;
  }

  const gallery = document.querySelector('product-gallery');
  
  if (gallery && !isInitialLoad) {
    gallery.classList.add('is-filtering');
  }

  const currentMapping = window.variantImageMapping.mapping.find(
    item => item.variantId === variantId.toString()
  );

  if (!currentMapping) {
    showAllImages();
    if (gallery) {
      gallery.classList.add('is-ready');
      gallery.classList.remove('is-filtering');
    }
    return;
  }

  const allowedMediaIds = currentMapping.mediaIds;
  const mediaElements = document.querySelectorAll('[data-media-id]');

  // Use requestAnimationFrame to defer state changes slightly.
  // This allows current execution frame observers in theme.js to settle before DOM changes happen.
  requestAnimationFrame(() => {
    mediaElements.forEach(element => {
      const elementMediaId = element.getAttribute('data-media-id');

      if (allowedMediaIds.includes(elementMediaId)) {
        element.style.display = ''; 
        element.removeAttribute('hidden');
        element.setAttribute('aria-hidden', 'false');
      } else {
        element.style.display = 'none';
        element.setAttribute('hidden', '');
        element.setAttribute('aria-hidden', 'true');
      }
    });

    // Reset carousel scroll position to start
    function scrollToFirstVisible() {
      const firstVisible = document.querySelector('.product-gallery__media:not([hidden])');
      if (!firstVisible) return;

      // Target the element, not a pixel offset, so scroll-snap lands on a real snap
      // point. block:'nearest' stops this from scrolling the page vertically.
      firstVisible.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'instant' });
    }

    scrollToFirstVisible();
    syncActiveThumbnail();

    // Force layout recalculation AFTER DOM updates have cleanly painted
    window.dispatchEvent(new Event('resize')); 

    if (gallery) {
      setTimeout(() => {
        if (isInitialLoad) {
          gallery.classList.add('is-ready');
        } else {
          gallery.classList.remove('is-filtering');
        }
        window.dispatchEvent(new Event('resize')); 
        scrollToFirstVisible();
        syncActiveThumbnail();
      }, 150);
    }
  });
}

function showAllImages() {
  document.querySelectorAll('[data-media-id]').forEach(el => {
    el.style.display = '';
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  });
}

// RUN ON VARIANT CHANGE
document.addEventListener('variant:change', function(event) {
  const activeVariant = event.detail.variant;
  if (activeVariant) {
    // Wrap in setTimeout 0 to push execution to the end of the current JS callstack,
    // ensuring Prestige's default variant-switch handler finishes execution first without throwing TypeError.
    setTimeout(() => {
      filterVariantImages(activeVariant.id, false);
    }, 0);
  }
});

// RUN ON INITIAL PAGE LOAD
window.addEventListener('load', function() {
  const urlParams = new URLSearchParams(window.location.search);
  let initialVariantId = urlParams.get('variant');

  if (!initialVariantId) {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      initialVariantId = variantInput.value;
    }
  }

  if (initialVariantId) {
    filterVariantImages(initialVariantId, true);
  } else {
    const gallery = document.querySelector('product-gallery');
    if (gallery) gallery.classList.add('is-ready');
  }
});

function syncActiveThumbnail() {
  const firstVisible = document.querySelector('.product-gallery__media:not([hidden])');
  if (!firstVisible) return;

  const activeMediaId = firstVisible.getAttribute('data-media-id');

  // Thumbnails (and dots, if they carry a media id) are the elements that track
  // active state with aria-current. Point them all at the first visible media.
  document.querySelectorAll('[data-media-id][aria-current]').forEach(el => {
    el.setAttribute('aria-current', el.getAttribute('data-media-id') === activeMediaId ? 'true' : 'false');
  });
}